module.exports = __webpack_public_path__ + "img/tripadvisor.a0b3fae9.svg";